import { RigidBody, CuboidCollider } from '@react-three/rapier';

function PhysicsWall({ size, pos, showMesh = false }) {
	return (
		<RigidBody type="fixed">
			<CuboidCollider args={size} position={pos} />
			{/* Visual indicator representation */}
			{showMesh && (
				<mesh position={pos}>
					<boxGeometry
						args={[size[0] * 2, size[1] * 2, size[2] * 2]}
					/>
					<meshBasicMaterial
						color={'black'}
						transparent={true}
						opacity={0.4}
					/>
				</mesh>
			)}
		</RigidBody>
	);
}

export default PhysicsWall;
